import { cn } from '@/shared/lib/cn';
import { Card } from '@/shared/ui/card';
import { formatCount, formatLongDate } from '../model/format';
import { quotaLimit, quotaSignal, remainingPercent } from '../model/quota';
import { CHANNEL_COPY, type AccountCapacity, type QuotaChannel } from '../model/types';

export function CapacityBanner({
  capacity,
  channel,
  title,
  unit,
  hint,
  live = true,
}: {
  capacity: AccountCapacity;
  channel: QuotaChannel;
  /** Padrão: "Saldo de e-mail" / "Saldo de SMS". */
  title?: string;
  /** Padrão: a unidade do canal. */
  unit?: string;
  hint?: string;
  live?: boolean;
}) {
  const copy = CHANNEL_COPY[channel];
  const unitLabel = unit ?? copy.unit;
  const limit = quotaLimit(capacity);
  const left = remainingPercent(capacity);
  const signal = quotaSignal(capacity);
  return (
    <Card className="p-4 sm:p-5">
      <div className="flex items-end justify-between gap-4">
        <div className="min-w-0">
          <p className="text-sm font-medium">{title ?? `Saldo de ${copy.label}`}</p>
          <p className="mt-1 text-2xl font-semibold tracking-tight tabular-nums">{formatCount(capacity.available)}</p>
          <p className="mt-0.5 text-xs text-muted-foreground">
            slots restantes de {formatCount(limit)} {unitLabel}
            {hint ? ` · ${hint}` : ''}
            {live ? '' : ' · última cota conhecida neste navegador'}
          </p>
        </div>
        <p className="shrink-0 text-right text-xs text-muted-foreground">
          Plano {capacity.planName}
          <span className="mt-1 block">Renova {formatLongDate(capacity.renewsOn)}</span>
        </p>
      </div>
      <div className="mt-4 h-1.5 overflow-hidden rounded-full bg-muted" aria-hidden>
        <div
          className={cn(
            'h-full rounded-full',
            signal === 'exhausted' ? 'bg-destructive' : signal === 'approaching' ? 'bg-warning' : 'bg-primary',
          )}
          style={{ width: `${left}%` }}
        />
      </div>
      <p className="mt-2 text-xs text-muted-foreground">
        {formatCount(capacity.sent)} {unitLabel} já saíram neste ciclo.
      </p>
    </Card>
  );
}
